<ng-container *transloco="let t">
  <authority-labs-base-dialog [dialogRef]="dialogRef" [title]="title">
    <div content>
      <authority-labs-crud-table
        [crudService]="inspectionTemplatesService"
        [columns]="columns"
        [filterParams]="filterParams"
        [disableDefaultColumns]="true"
        [autoHeight]="true"
        [hideActionsColumn]="true"
        [isSelectable]="true"
        (rowSelected)="templateSelected($event)"
      >
      </authority-labs-crud-table>
    </div>

    <button
      actions
      nz-button
      (click)="chooseAndClose()"
      *ngIf="selectedTemplate"
      style="margin-left: 10px"
    >
      בחר
    </button>
  </authority-labs-base-dialog>
</ng-container>
